import React from 'react';
import { Tooltip as MuiTooltip, TooltipProps } from '@material-ui/core';
import styled from 'styled-components';

interface IProps extends TooltipProps {
    className?: string;
}

const BaseTooltip = ({ className, ...other }: IProps) => (
    <MuiTooltip classes={{ tooltip: className }} {...other} />
);

export const Tooltip = styled(BaseTooltip)`
    background-color: ${({ theme }) => theme.palette.divider};
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
    font-weight: 700;
    border-radius: 0;
    padding: ${({ theme }) => `${theme.spacing(2)}px ${theme.spacing(2)}px`};
    line-height: 1;

    &.MuiTooltip-tooltipPlacementTop {
        margin: ${({ theme }) => `${theme.spacing(1)}px 0`};
    }
`;
